// extracted by mini-css-extract-plugin
export default {"answerTextBox":"QuestionView__answerTextBox___F2HBY"};